import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";
import {
  FileText, TrendingUp, DollarSign, Clock, X, BookOpen,
  Printer, Search, Filter, Download, CheckSquare, Square,
  ChevronRight, CalendarCheck, ChevronLeft, Trash2, AlertTriangle,
  Mail, Send, Paperclip, Eye, ExternalLink, UserPlus, CheckCircle
} from "lucide-react";
import * as XLSX from "xlsx";

const N8N_INVITAR_PORTAL = "https://n8n.tuaplicacion.cl/webhook/invitar-cliente";

function money(n) {
  return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n || 0);
}
function fmtDate(d) {
  if (!d) return "—";
  return new Date(d + "T12:00:00").toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" });
}

  function diasSinPagar(f) {
      if (!f || f.estado === "pagada" || f.estado === "anulada") return null;
     if (!f.fecha_emision) return null;
      return Math.floor((new Date() - new Date(f.fecha_emision + "T12:00:00")) / 864e5);
    }
    function DiasBadge({ dias }) {
      if (dias === null) return <span style={{ color:"#cbd5e1", fontSize:12 }}>—</span>;
      const color = dias > 60 ? "#dc2626" : dias > 30 ? "#f59e0b" : "#64748b";
      const bg    = dias > 60 ? "#fef2f2" : dias > 30 ? "#fffbeb" : "transparent";
      return <span style={{ color, background:bg, borderRadius:5,
        padding: dias > 30 ? "2px 7px" : 0, fontSize:12, fontWeight: dias > 30 ? 700 : 400 }}>
        {dias}d
      </span>;
    }

const ESTADO_COLORS = {
  emitida: { bg: "#fff8e1", color: "#e65100", label: "Emitida" },
  pagada:  { bg: "#e8f5e9", color: "#2e7d32", label: "Pagada" },
  anulada: { bg: "#fce4ec", color: "#c62828", label: "Anulada" },
  vencida: { bg: "#fbe9e7", color: "#bf360c", label: "Vencida" },
};

const CUENTAS_REMITENTE = [
  { email: "contacto@tuaplicacion.cl", label: "contacto@tuaplicacion.cl" },
  { email: "ivan@tuaplicacion.cl",     label: "ivan@tuaplicacion.cl" },
];

function EstadoBadge({ estado }) {
  const s = ESTADO_COLORS[estado] || ESTADO_COLORS.emitida;
  return <span style={{ background: s.bg, color: s.color, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>{s.label}</span>;
}

function KPI({ icon: Icon, label, value, color, sub }) {
  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", display: "flex", alignItems: "center", gap: 16, boxShadow: "0 1px 6px #0000000a", flex: 1 }}>
      <div style={{ width: 44, height: 44, borderRadius: 10, background: color + "15", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon size={20} color={color} />
      </div>
      <div>
        <div style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase" }}>{label}</div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "#0d1117", marginTop: 2 }}>{value}</div>
        {sub && <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 1 }}>{sub}</div>}
      </div>
    </div>
  );
}

function Paginacion({ total, pagina, porPagina, onChange }) {
  const totalPaginas = Math.ceil(total / porPagina);
  if (totalPaginas <= 1) return null;
  const paginas = [];
  for (let i = 1; i <= totalPaginas; i++) {
    if (i === 1 || i === totalPaginas || Math.abs(i - pagina) <= 1) paginas.push(i);
    else if (paginas[paginas.length - 1] !== "...") paginas.push("...");
  }
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: "1px solid #e2e8f0" }}>
      <div style={{ fontSize: 12, color: "#94a3b8" }}>Mostrando {Math.min((pagina - 1) * porPagina + 1, total)}–{Math.min(pagina * porPagina, total)} de {total}</div>
      <div style={{ display: "flex", gap: 4 }}>
        <button onClick={() => onChange(pagina - 1)} disabled={pagina === 1} style={{ width: 32, height: 32, border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff", cursor: pagina === 1 ? "not-allowed" : "pointer", color: pagina === 1 ? "#cbd5e1" : "#374151", display: "flex", alignItems: "center", justifyContent: "center" }}><ChevronLeft size={14} /></button>
        {paginas.map((p, i) => <button key={i} onClick={() => p !== "..." && onChange(p)} disabled={p === "..."} style={{ minWidth: 32, height: 32, border: `1px solid ${p === pagina ? "#29abe2" : "#e2e8f0"}`, borderRadius: 7, background: p === pagina ? "#29abe2" : "#fff", cursor: p === "..." ? "default" : "pointer", color: p === pagina ? "#fff" : "#374151", fontSize: 12, fontWeight: p === pagina ? 700 : 400, fontFamily: "inherit" }}>{p}</button>)}
        <button onClick={() => onChange(pagina + 1)} disabled={pagina === totalPaginas} style={{ width: 32, height: 32, border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff", cursor: pagina === totalPaginas ? "not-allowed" : "pointer", color: pagina === totalPaginas ? "#cbd5e1" : "#374151", display: "flex", alignItems: "center", justifyContent: "center" }}><ChevronRight size={14} /></button>
      </div>
    </div>
  );
}

function FiltroPanel({ open, onClose, filtros, onChange, periodos, onLimpiar }) {
  const hayFiltros = Object.values(filtros).some(v => v);
  const inputStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", color: "#0d1117", background: "#fff", boxSizing: "border-box" };
  return (
    <>
      {open && <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000030", zIndex: 150 }} />}
      <div style={{ position: "fixed", top: 0, right: 0, height: "100vh", width: 320, background: "#fff", boxShadow: "-8px 0 32px #00000015", zIndex: 160, display: "flex", flexDirection: "column", transform: open ? "translateX(0)" : "translateX(100%)", transition: "transform .3s cubic-bezier(.4,0,.2,1)", fontFamily: "'DM Sans', sans-serif" }}>
        <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div><div style={{ fontSize: 15, fontWeight: 700, color: "#0d1117" }}>Filtros</div>{hayFiltros && <div style={{ fontSize: 11, color: "#29abe2", marginTop: 2 }}>Filtros activos</div>}</div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={20} /></button>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 20 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 8 }}>Buscar cliente / RUT</label>
            <div style={{ position: "relative" }}><Search size={13} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} /><input value={filtros.busqueda} onChange={e => onChange("busqueda", e.target.value)} placeholder="Nombre o RUT..." style={{ ...inputStyle, paddingLeft: 32 }} /></div>
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 8 }}>Período</label>
            <select value={filtros.periodo} onChange={e => onChange("periodo", e.target.value)} style={{ ...inputStyle, appearance: "none" }}><option value="">Todos los períodos</option>{periodos.map(p => <option key={p} value={p}>{p}</option>)}</select>
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 8 }}>Estado</label>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {[{ v: "", l: "Todos" }, { v: "emitida", l: "Emitida" }, { v: "pagada", l: "Pagada" }, { v: "anulada", l: "Anulada" }].map(({ v, l }) => (
                <button key={v} onClick={() => onChange("estado", v)} style={{ padding: "9px 14px", border: `1.5px solid ${filtros.estado === v ? "#29abe2" : "#e2e8f0"}`, borderRadius: 8, background: filtros.estado === v ? "#29abe210" : "#fff", color: filtros.estado === v ? "#29abe2" : "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", textAlign: "left" }}>{l}</button>
              ))}
            </div>
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 8 }}>Rango de fechas</label>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div><div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4 }}>Desde</div><input type="date" value={filtros.fechaDesde} onChange={e => onChange("fechaDesde", e.target.value)} style={inputStyle} /></div>
              <div><div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4 }}>Hasta</div><input type="date" value={filtros.fechaHasta} onChange={e => onChange("fechaHasta", e.target.value)} style={inputStyle} /></div>
            </div>
          </div>
        </div>
        {hayFiltros && <div style={{ padding: "16px 24px", borderTop: "1px solid #e2e8f0" }}><button onClick={onLimpiar} style={{ width: "100%", padding: "10px", border: "1.5px solid #fecaca", borderRadius: 8, background: "#fef2f2", color: "#dc2626", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Limpiar todos los filtros</button></div>}
      </div>
    </>
  );
}
/* ── Modal Cobranza ── */
function CobranzaModal({ facturas, onClose }) {
  const inputStyle = {
    width: "100%", padding: "9px 14px", border: "1.5px solid #e2e8f0",
    borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none",
    color: "#0d1117", background: "#fff", boxSizing: "border-box",
  };
  const { contactos } = useContactos();
  const [desde, setDesde] = useState(CUENTAS_REMITENTE[0].email);
  const [para, setPara] = useState("");
  const [showSug, setShowSug] = useState(false);
  const [asunto, setAsunto] = useState("Aviso de cobranza — documentos pendientes de pago");
  const [intro, setIntro] = useState(
    "Estimado/a,\n\nNos dirigimos a usted para informarle que los siguientes documentos se encuentran pendientes de pago:"
  );
  const [cierre, setCierre] = useState(
    "Le solicitamos gestionar el pago a la brevedad. Ante cualquier consulta, no dude en contactarnos.\n\nSaludos cordiales,\nTuAplicacion"
  );
  const [adjuntarPdfs, setAdjuntarPdfs] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");

  const hoy = new Date();
  const N8N_WEBHOOK_URL = "https://n8n.tuaplicacion.cl/webhook/send-email-factura";
  const totalDeuda = facturas.reduce((s, f) => s + (f.monto_total || 0), 0);

  // Autocompletar con el primer contacto que coincida
  useEffect(() => {
    if (facturas.length > 0) {
      const c = contactos.find(x => x.rut === facturas[0].rut_cliente);
      if (c?.email) setPara(c.email);
    }
  }, [contactos]);

  const sugerencias = para.length >= 2
    ? contactos.filter(c => c.email && (
        c.email.toLowerCase().includes(para.toLowerCase()) ||
        (c.razon_social || "").toLowerCase().includes(para.toLowerCase())
      ))
    : [];

  function tablaHtml() {
    const filas = facturas.map(f => {
      const dias = Math.floor((hoy - new Date(f.fecha_emision + "T12:00:00")) / 864e5);
      const dColor = dias > 60 ? "#dc2626" : dias > 30 ? "#f59e0b" : "#374151";
      return `<tr>
        <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0">${f.folio}</td>
        <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0">${fmtDate(f.fecha_emision)}</td>
        <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0;text-align:center;font-weight:600;color:${dColor}">${dias} días</td>
        <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0;text-align:right;font-weight:700">${money(f.monto_total)}</td>
      </tr>`;
    }).join("");
    return `<table style="width:100%;border-collapse:collapse;font-family:sans-serif;font-size:13px;margin:16px 0">
      <thead>
        <tr style="background:#0d1117;color:#fff">
          <th style="padding:10px 12px;text-align:left">N° Documento</th>
          <th style="padding:10px 12px;text-align:left">Fecha Emisión</th>
          <th style="padding:10px 12px;text-align:center">Días pendiente</th>
          <th style="padding:10px 12px;text-align:right">Monto</th>
        </tr>
      </thead>
      <tbody>${filas}</tbody>
      <tfoot>
        <tr style="background:#f8fafc">
          <td colspan="3" style="padding:10px 12px;font-weight:800">TOTAL</td>
          <td style="padding:10px 12px;text-align:right;font-weight:800">${money(totalDeuda)}</td>
        </tr>
      </tfoot>
    </table>`;
  }

  async function enviar() {
    if (!para.trim()) { setError("Ingresa el destinatario."); return; }
    setEnviando(true); setError("");
    try {
      const res = await fetch(N8N_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          desde,
          para,
          asunto,
          cuerpo: intro + "\n\n" + tablaHtml() + "\n\n" + cierre,
          tipo: "cobranza",
          pdf_drive_id: adjuntarPdfs
            ? facturas.filter(f => f.pdf_drive_id).map(f => f.pdf_drive_id)
            : [],
          facturas_count: facturas.length,
          total_deuda: totalDeuda,
        }),
      });
      if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
      setEnviado(true);
    } catch (e) {
      setError("Error al enviar: " + e.message);
    }
    setEnviando(false);
  }

  if (enviado) return (
    <div style={{ position:"fixed", inset:0, background:"#00000050", display:"flex",
      alignItems:"center", justifyContent:"center", zIndex:250,
      fontFamily:"'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:16, width:420, padding:"40px 32px",
        textAlign:"center", boxShadow:"0 20px 60px #00000020" }}
        onClick={e => e.stopPropagation()}>
        <div style={{ width:64, height:64, borderRadius:"50%", background:"#fef2f2",
          border:"2px solid #fecaca", display:"flex", alignItems:"center",
          justifyContent:"center", margin:"0 auto 16px" }}>
          <Send size={28} color="#dc2626" />
        </div>
        <div style={{ fontSize:18, fontWeight:800, color:"#0d1117", marginBottom:8 }}>
          ¡Cobranza enviada!
        </div>
        <div style={{ fontSize:13, color:"#64748b", marginBottom:24 }}>
          <strong>{facturas.length}</strong> documentos por{" "}
          <strong>{money(totalDeuda)}</strong> enviados a <strong>{para}</strong>
        </div>
        <button onClick={onClose}
          style={{ padding:"10px 28px", border:"none", borderRadius:8,
            background:"#dc2626", color:"#fff", fontSize:13, fontWeight:700,
            cursor:"pointer", fontFamily:"inherit" }}>
          Cerrar
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ position:"fixed", inset:0, background:"#00000050", display:"flex",
      alignItems:"center", justifyContent:"center", zIndex:250,
      fontFamily:"'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background:"#fff", borderRadius:16, width:660, maxHeight:"93vh",
        overflow:"hidden", display:"flex", flexDirection:"column",
        boxShadow:"0 20px 60px #00000025" }}
        onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding:"18px 24px", borderBottom:"1px solid #e2e8f0",
          display:"flex", justifyContent:"space-between", alignItems:"center",
          background:"#fef2f2", flexShrink:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:36, height:36, borderRadius:8, background:"#fee2e2",
              display:"flex", alignItems:"center", justifyContent:"center" }}>
              <Mail size={18} color="#dc2626" />
            </div>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:"#0d1117" }}>
                Enviar cobranza
              </div>
              <div style={{ fontSize:11, color:"#94a3b8" }}>
                {facturas.length} documentos · Total {money(totalDeuda)}
              </div>
            </div>
          </div>
          <button onClick={onClose}
            style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8" }}>
            <X size={18} />
          </button>
        </div>

        <div style={{ flex:1, overflowY:"auto", padding:"20px 24px",
          display:"flex", flexDirection:"column", gap:14 }}>

          {/* Desde */}
          <div>
            <label style={{ fontSize:11, fontWeight:700, color:"#64748b", letterSpacing:1,
              textTransform:"uppercase", display:"block", marginBottom:6 }}>Desde</label>
            <div style={{ display:"flex", gap:8 }}>
              {CUENTAS_REMITENTE.map(c => (
                <button key={c.email} onClick={() => setDesde(c.email)}
                  style={{ flex:1, padding:"9px 12px",
                    border:`1.5px solid ${desde === c.email ? "#dc2626" : "#e2e8f0"}`,
                    borderRadius:8,
                    background: desde === c.email ? "#fef2f2" : "#fff",
                    color: desde === c.email ? "#dc2626" : "#374151",
                    fontSize:12, fontWeight: desde === c.email ? 700 : 500,
                    cursor:"pointer", fontFamily:"inherit" }}>
                  {c.label}
                </button>
              ))}
            </div>
          </div>

          {/* Para */}
          <div>
            <label style={{ fontSize:11, fontWeight:700, color:"#64748b", letterSpacing:1,
              textTransform:"uppercase", display:"block", marginBottom:6 }}>Para</label>
            <div style={{ position:"relative" }}>
              <input
                value={para}
                onChange={e => { setPara(e.target.value); setShowSug(true); }}
                onFocus={() => setShowSug(true)}
                onBlur={() => setTimeout(() => setShowSug(false), 150)}
                placeholder="destinatario@empresa.com"
                style={inputStyle}
              />
              {showSug && sugerencias.length > 0 && (
                <div style={{ position:"absolute", top:"100%", left:0, right:0,
                  background:"#fff", border:"1.5px solid #e2e8f0", borderRadius:8,
                  boxShadow:"0 8px 24px #00000015", zIndex:10, overflow:"hidden" }}>
                  {sugerencias.map(c => (
                    <button key={c.rut}
                      onClick={() => { setPara(c.email); setShowSug(false); }}
                      style={{ width:"100%", padding:"9px 14px", border:"none",
                        background:"transparent", cursor:"pointer", textAlign:"left",
                        fontFamily:"inherit", display:"flex", justifyContent:"space-between",
                        alignItems:"center", borderBottom:"1px solid #f8fafc" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <span style={{ fontSize:13, fontWeight:600, color:"#0d1117" }}>
                        {c.razon_social || c.rut}
                      </span>
                      <span style={{ fontSize:12, color:"#3b82f6" }}>{c.email}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Asunto */}
          <div>
            <label style={{ fontSize:11, fontWeight:700, color:"#64748b", letterSpacing:1,
              textTransform:"uppercase", display:"block", marginBottom:6 }}>Asunto</label>
            <input value={asunto} onChange={e => setAsunto(e.target.value)} style={inputStyle} />
          </div>

          {/* Introducción */}
          <div>
            <label style={{ fontSize:11, fontWeight:700, color:"#64748b", letterSpacing:1,
              textTransform:"uppercase", display:"block", marginBottom:6 }}>Introducción</label>
            <textarea value={intro} onChange={e => setIntro(e.target.value)}
              rows={3} style={{ ...inputStyle, resize:"vertical", lineHeight:1.6 }} />
          </div>

          {/* Preview tabla */}
          <div>
            <label style={{ fontSize:11, fontWeight:700, color:"#64748b", letterSpacing:1,
              textTransform:"uppercase", display:"block", marginBottom:8 }}>
              Tabla (se incluye automáticamente en el email)
            </label>
            <div style={{ border:"1px solid #e2e8f0", borderRadius:8, overflow:"hidden" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
                <thead>
                  <tr style={{ background:"#0d1117", color:"#fff" }}>
                    {["N° Doc.", "Fecha Emisión", "Días pendiente", "Monto"].map(h => (
                      <th key={h} style={{ padding:"8px 12px", fontWeight:700, fontSize:11,
                        textAlign: h === "Monto" ? "right" : h === "Días pendiente" ? "center" : "left" }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {facturas.map((f, i) => {
                    const dias = Math.floor((hoy - new Date(f.fecha_emision + "T12:00:00")) / 864e5);
                    return (
                      <tr key={f.id}
                        style={{ borderBottom:"1px solid #f0f4f8",
                          background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
                        <td style={{ padding:"7px 12px", fontWeight:600, color:"#29abe2" }}>
                          {f.folio}
                        </td>
                        <td style={{ padding:"7px 12px", color:"#64748b" }}>
                          {fmtDate(f.fecha_emision)}
                        </td>
                        <td style={{ padding:"7px 12px", textAlign:"center", fontWeight:700,
                          color: dias > 60 ? "#dc2626" : dias > 30 ? "#f59e0b" : "#374151" }}>
                          {dias} días
                        </td>
                        <td style={{ padding:"7px 12px", textAlign:"right", fontWeight:700 }}>
                          {money(f.monto_total)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr style={{ background:"#f8fafc", borderTop:"2px solid #e2e8f0" }}>
                    <td colSpan={3} style={{ padding:"8px 12px", fontWeight:800, fontSize:12 }}>
                      TOTAL
                    </td>
                    <td style={{ padding:"8px 12px", textAlign:"right", fontWeight:800 }}>
                      {money(totalDeuda)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Cierre */}
          <div>
            <label style={{ fontSize:11, fontWeight:700, color:"#64748b", letterSpacing:1,
              textTransform:"uppercase", display:"block", marginBottom:6 }}>Cierre</label>
            <textarea value={cierre} onChange={e => setCierre(e.target.value)}
              rows={3} style={{ ...inputStyle, resize:"vertical", lineHeight:1.6 }} />
          </div>

          {/* Toggle PDFs */}
          <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:8,
            padding:"12px 14px", display:"flex", alignItems:"center",
            justifyContent:"space-between" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <Paperclip size={14} color="#64748b" />
              <div>
                <div style={{ fontSize:12, fontWeight:700, color:"#374151" }}>
                  Adjuntar PDFs de los documentos
                </div>
                <div style={{ fontSize:11, color:"#64748b" }}>
                  {facturas.filter(f => f.pdf_drive_id).length} de {facturas.length} tienen PDF en Drive
                </div>
              </div>
            </div>
            <button onClick={() => setAdjuntarPdfs(!adjuntarPdfs)}
              style={{ width:40, height:22, borderRadius:11,
                background: adjuntarPdfs ? "#dc2626" : "#e2e8f0",
                border:"none", cursor:"pointer", position:"relative",
                transition:"background .2s", flexShrink:0 }}>
              <div style={{ width:18, height:18, borderRadius:"50%", background:"#fff",
                position:"absolute", top:2, left: adjuntarPdfs ? 20 : 2,
                transition:"left .2s", boxShadow:"0 1px 3px #00000020" }} />
            </button>
          </div>

          {error && (
            <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8,
              padding:"10px 14px", fontSize:12, color:"#dc2626", fontWeight:500 }}>
              {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding:"16px 24px", borderTop:"1px solid #e2e8f0",
          display:"flex", gap:10, flexShrink:0 }}>
          <button onClick={onClose}
            style={{ flex:1, padding:"11px", border:"1.5px solid #e2e8f0", borderRadius:8,
              background:"#fff", color:"#374151", fontSize:13, fontWeight:600,
              cursor:"pointer", fontFamily:"inherit" }}>
            Cancelar
          </button>
          <button onClick={enviar} disabled={enviando}
            style={{ flex:2, padding:"11px", border:"none", borderRadius:8,
              background: enviando ? "#fca5a5" : "#dc2626", color:"#fff",
              fontSize:13, fontWeight:700,
              cursor: enviando ? "not-allowed" : "pointer",
              fontFamily:"inherit", display:"flex", alignItems:"center",
              justifyContent:"center", gap:8 }}>
            <Send size={14} />
            {enviando ? "Enviando..." : `Enviar cobranza (${facturas.length} docs)`}
          </button>
        </div>
      </div>
    </div>
  );
}


/* ── Email Masivo Modal ── */
function EmailMasivoModal({ facturas, onClose }) {
  const inputStyle = { width: "100%", padding: "9px 14px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", color: "#0d1117", background: "#fff", boxSizing: "border-box" };
  const { contactos } = useContactos();
  const [desde, setDesde] = useState(CUENTAS_REMITENTE[0].email);
  const [para, setPara] = useState("");
  const [showSugerencias, setShowSugerencias] = useState(false);
  const [asuntoTemplate, setAsuntoTemplate] = useState("Factura N° {folio} - {cliente}");
  const [cuerpoTemplate, setCuerpoTemplate] = useState("Estimado/a,\n\nAdjunto encontrará la factura N° {folio} emitida el {fecha} por un total de {total}.\n\nQuedamos a su disposición ante cualquier consulta.\n\nSaludos cordiales,\nTuAplicacion");
  const [adjuntarPdf, setAdjuntarPdf] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [progreso, setProgreso] = useState(null);
  const [terminado, setTerminado] = useState(false);

  // Si todas las facturas son del mismo cliente, autocompletar desde contactos
  useEffect(() => {
    if (facturas.length === 1) {
      const contacto = contactos.find(c => c.rut === facturas[0].rut_cliente);
      if (contacto?.email) setPara(contacto.email);
    }
  }, [contactos]);

  const sugerencias = para.length >= 2
    ? contactos.filter(c => c.email && (
        c.email.toLowerCase().includes(para.toLowerCase()) ||
        (c.razon_social || "").toLowerCase().includes(para.toLowerCase())
      ))
    : [];

  const N8N_WEBHOOK_URL = "https://tuaplicacion.app.n8n.cloud/webhook/send-email-factura";

  function resolverTemplate(template, factura) {
    return template
      .replace(/{folio}/g, factura.folio || "")
      .replace(/{cliente}/g, factura.razon_cliente || "")
      .replace(/{fecha}/g, fmtDate(factura.fecha_emision))
      .replace(/{total}/g, money(factura.monto_total))
      .replace(/{rut}/g, factura.rut_cliente || "")
      .replace(/{periodo}/g, factura.periodo || "");
  }

  async function enviarTodas() {
    if (!para.trim()) { alert("Ingresa el destinatario."); return; }
    setEnviando(true);
    const errores = [];
    setProgreso({ actual: 0, total: facturas.length, ok: 0, errores: [] });

    for (let i = 0; i < facturas.length; i++) {
      const f = facturas[i];
      try {
        const res = await fetch(N8N_WEBHOOK_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            desde,
            para,
            asunto: resolverTemplate(asuntoTemplate, f),
            cuerpo: resolverTemplate(cuerpoTemplate, f),
            pdf_drive_id: adjuntarPdf && f.pdf_drive_id ? f.pdf_drive_id : null,
            folio: f.folio,
            razon_cliente: f.razon_cliente,
          })
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        setProgreso(p => ({ ...p, actual: i + 1, ok: p.ok + 1 }));
      } catch (e) {
        errores.push(`N° ${f.folio}: ${e.message}`);
        setProgreso(p => ({ ...p, actual: i + 1, errores: [...p.errores, `N° ${f.folio}`] }));
      }
      // pequeña pausa entre envíos
      if (i < facturas.length - 1) await new Promise(r => setTimeout(r, 500));
    }
    setEnviando(false);
    setTerminado(true);
  }

  if (terminado && progreso) {
    return (
      <div style={{ position: "fixed", inset: 0, background: "#00000050", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 250, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
        <div style={{ background: "#fff", borderRadius: 16, width: 420, padding: "36px 32px", textAlign: "center", boxShadow: "0 20px 60px #00000020" }} onClick={e => e.stopPropagation()}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: progreso.errores.length === 0 ? "#f0fdf4" : "#fffbeb", border: `2px solid ${progreso.errores.length === 0 ? "#bbf7d0" : "#fde68a"}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
            <Send size={28} color={progreso.errores.length === 0 ? "#10b981" : "#f59e0b"} />
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, color: "#0d1117", marginBottom: 8 }}>
            {progreso.errores.length === 0 ? "¡Todos los emails enviados!" : `${progreso.ok} de ${progreso.total} enviados`}
          </div>
          <div style={{ fontSize: 13, color: "#64748b", marginBottom: progreso.errores.length ? 16 : 24 }}>
            Se enviaron <strong>{progreso.ok}</strong> facturas a <strong>{para}</strong>
          </div>
          {progreso.errores.length > 0 && (
            <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", marginBottom: 20, textAlign: "left" }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#dc2626", marginBottom: 4 }}>Fallaron:</div>
              {progreso.errores.map((e, i) => <div key={i} style={{ fontSize: 12, color: "#dc2626" }}>{e}</div>)}
            </div>
          )}
          <button onClick={onClose} style={{ padding: "10px 28px", border: "none", borderRadius: 8, background: "#10b981", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Cerrar</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000050", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 250, fontFamily: "'DM Sans', sans-serif" }} onClick={!enviando ? onClose : undefined}>
      <div style={{ background: "#fff", borderRadius: 16, width: 600, maxHeight: "92vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px #00000025" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "18px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center" }}><Mail size={18} color="#3b82f6" /></div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#0d1117" }}>Envío masivo de facturas</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>{facturas.length} facturas seleccionadas</div>
            </div>
          </div>
          {!enviando && <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={18} /></button>}
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14 }}>

          {/* Progreso */}
          {enviando && progreso && (
            <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "16px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#1d4ed8" }}>Enviando facturas...</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#1d4ed8" }}>{progreso.actual}/{progreso.total}</span>
              </div>
              <div style={{ height: 6, background: "#bfdbfe", borderRadius: 3, overflow: "hidden" }}>
                <div style={{ height: "100%", background: "#3b82f6", borderRadius: 3, width: `${(progreso.actual / progreso.total) * 100}%`, transition: "width .3s" }} />
              </div>
              {progreso.errores.length > 0 && <div style={{ marginTop: 8, fontSize: 11, color: "#dc2626" }}>Fallaron: {progreso.errores.join(", ")}</div>}
            </div>
          )}

          {/* Desde */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Desde</label>
            <div style={{ display: "flex", gap: 8 }}>
              {CUENTAS_REMITENTE.map(c => (
                <button key={c.email} onClick={() => setDesde(c.email)} disabled={enviando} style={{ flex: 1, padding: "9px 12px", border: `1.5px solid ${desde === c.email ? "#3b82f6" : "#e2e8f0"}`, borderRadius: 8, background: desde === c.email ? "#eff6ff" : "#fff", color: desde === c.email ? "#1d4ed8" : "#374151", fontSize: 12, fontWeight: desde === c.email ? 700 : 500, cursor: "pointer", fontFamily: "inherit" }}>{c.label}</button>
              ))}
            </div>
          </div>

          {/* Para */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Para (mismo destinatario para todas)</label>
            <div style={{ position: "relative" }}>
              <input
                value={para}
                onChange={e => { setPara(e.target.value); setShowSugerencias(true); }}
                onFocus={() => setShowSugerencias(true)}
                onBlur={() => setTimeout(() => setShowSugerencias(false), 150)}
                placeholder="destinatario@empresa.com"
                style={inputStyle}
                disabled={enviando}
              />
              {showSugerencias && sugerencias.length > 0 && !enviando && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 8, boxShadow: "0 8px 24px #00000015", zIndex: 10, overflow: "hidden" }}>
                  {sugerencias.map(c => (
                    <button key={c.rut} onClick={() => { setPara(c.email); setShowSugerencias(false); }}
                      style={{ width: "100%", padding: "9px 14px", border: "none", background: "transparent", cursor: "pointer", textAlign: "left", fontFamily: "inherit", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f8fafc" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#0d1117" }}>{c.razon_social || c.rut}</span>
                      <span style={{ fontSize: 12, color: "#3b82f6" }}>{c.email}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Asunto template */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Asunto</label>
            <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 6 }}>Variables: <code>{"{folio}"}</code> <code>{"{cliente}"}</code> <code>{"{total}"}</code> <code>{"{fecha}"}</code> <code>{"{rut}"}</code></div>
            <input value={asuntoTemplate} onChange={e => setAsuntoTemplate(e.target.value)} style={inputStyle} disabled={enviando} />
          </div>

          {/* Cuerpo template */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 4 }}>Contenido</label>
            <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 6 }}>Mismas variables disponibles — se reemplazan automáticamente por cada factura</div>
            <textarea value={cuerpoTemplate} onChange={e => setCuerpoTemplate(e.target.value)} rows={6} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} disabled={enviando} />
          </div>

          {/* PDF toggle */}
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "12px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Paperclip size={14} color="#3b82f6" />
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>Adjuntar PDF de Drive</div>
                <div style={{ fontSize: 11, color: "#64748b" }}>{facturas.filter(f => f.pdf_drive_id).length} de {facturas.length} facturas tienen PDF</div>
              </div>
            </div>
            <button onClick={() => setAdjuntarPdf(!adjuntarPdf)} disabled={enviando}
              style={{ width: 40, height: 22, borderRadius: 11, background: adjuntarPdf ? "#3b82f6" : "#e2e8f0", border: "none", cursor: "pointer", position: "relative", transition: "background .2s", flexShrink: 0 }}>
              <div style={{ width: 18, height: 18, borderRadius: "50%", background: "#fff", position: "absolute", top: 2, left: adjuntarPdf ? 20 : 2, transition: "left .2s", boxShadow: "0 1px 3px #00000020" }} />
            </button>
          </div>

          {/* Lista de facturas */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 8 }}>Facturas a enviar</label>
            <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", maxHeight: 160, overflowY: "auto" }}>
              {facturas.map((f, i) => (
                <div key={f.id} style={{ padding: "8px 14px", borderBottom: i < facturas.length - 1 ? "1px solid #f8fafc" : "none", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {progreso && progreso.actual > i && (
                      <span style={{ fontSize: 11, color: progreso.errores.includes(`N° ${f.folio}`) ? "#dc2626" : "#10b981" }}>
                        {progreso.errores.includes(`N° ${f.folio}`) ? "✗" : "✓"}
                      </span>
                    )}
                    <span style={{ fontWeight: 600, color: "#374151" }}>N° {f.folio}</span>
                    <span style={{ color: "#94a3b8" }}>— {f.razon_cliente}</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span style={{ color: "#10b981", fontWeight: 700 }}>{money(f.monto_total)}</span>
                    {f.pdf_drive_id && <span style={{ fontSize: 10, color: "#3b82f6", background: "#eff6ff", borderRadius: 4, padding: "1px 5px" }}>PDF</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "16px 24px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 10, flexShrink: 0 }}>
          <button onClick={onClose} disabled={enviando} style={{ flex: 1, padding: "11px", border: "1.5px solid #e2e8f0", borderRadius: 8, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: enviando ? "not-allowed" : "pointer", fontFamily: "inherit", opacity: enviando ? 0.5 : 1 }}>Cancelar</button>
          <button onClick={enviarTodas} disabled={enviando}
            style={{ flex: 2, padding: "11px", border: "none", borderRadius: 8, background: enviando ? "#93c5fd" : "#3b82f6", color: "#fff", fontSize: 13, fontWeight: 700, cursor: enviando ? "not-allowed" : "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
            <Send size={14} />{enviando ? `Enviando ${progreso?.actual || 0}/${facturas.length}...` : `Enviar ${facturas.length} facturas`}
          </button>
        </div>
      </div>
    </div>
  );
}

function PagoMasivoModal({ facturas, onClose, onConfirm }) {
  const [fechaPago, setFechaPago] = useState(new Date().toISOString().split("T")[0]);
  const [guardando, setGuardando] = useState(false);
  const total = facturas.reduce((s, f) => s + (f.monto_total || 0), 0);
  async function confirmar() { setGuardando(true); await onConfirm(facturas.map(f => f.id), fechaPago); setGuardando(false); onClose(); }
  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000040", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: 440, boxShadow: "0 20px 60px #00000020" }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}><CalendarCheck size={18} color="#10b981" /><div style={{ fontSize: 15, fontWeight: 700, color: "#0d1117" }}>Registrar pago masivo</div></div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={18} /></button>
        </div>
        <div style={{ padding: "20px 24px" }}>
          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "14px 16px", marginBottom: 20 }}>
            <div style={{ fontSize: 12, color: "#166534", fontWeight: 600, marginBottom: 4 }}>{facturas.length} facturas seleccionadas</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: "#166534" }}>{money(total)}</div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 8 }}>Fecha de pago</label>
            <input type="date" value={fechaPago} onChange={e => setFechaPago(e.target.value)} style={{ width: "100%", padding: "10px 14px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ maxHeight: 160, overflowY: "auto", marginBottom: 16, border: "1px solid #e2e8f0", borderRadius: 8 }}>
            {facturas.map(f => <div key={f.id} style={{ padding: "8px 14px", borderBottom: "1px solid #f8fafc", display: "flex", justifyContent: "space-between", fontSize: 12 }}><span style={{ color: "#374151", fontWeight: 600 }}>N° {f.folio} — {f.razon_cliente}</span><span style={{ color: "#10b981", fontWeight: 700 }}>{money(f.monto_total)}</span></div>)}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={onClose} style={{ flex: 1, padding: "10px", border: "1.5px solid #e2e8f0", borderRadius: 8, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Cancelar</button>
            <button onClick={confirmar} disabled={guardando} style={{ flex: 1, padding: "10px", border: "none", borderRadius: 8, background: "#10b981", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>{guardando ? "Guardando..." : "Confirmar pago"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ConfirmarEliminarModal({ factura, onClose, onConfirm }) {
  const [eliminando, setEliminando] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const confirmWord = String(factura.folio);
  const puedeEliminar = confirmText === confirmWord;
  async function handleEliminar() {
    if (!puedeEliminar) return;
    setEliminando(true);
    await onConfirm(factura.id);
    setEliminando(false);
    onClose();
  }
  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000060", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 300, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: 440, boxShadow: "0 20px 60px #00000030", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
        <div style={{ background: "#fef2f2", padding: "20px 24px", borderBottom: "1px solid #fecaca", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 10, background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><AlertTriangle size={20} color="#dc2626" /></div>
          <div><div style={{ fontSize: 15, fontWeight: 800, color: "#991b1b" }}>Eliminar factura</div><div style={{ fontSize: 12, color: "#b91c1c", marginTop: 2 }}>Esta acción no se puede deshacer</div></div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", marginLeft: "auto" }}><X size={18} /></button>
        </div>
        <div style={{ padding: "20px 24px" }}>
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "14px 16px", marginBottom: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}><span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Folio</span><span style={{ fontSize: 12, fontWeight: 800, color: "#0d1117" }}>N° {factura.folio}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}><span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Cliente</span><span style={{ fontSize: 12, fontWeight: 600, color: "#0d1117" }}>{factura.razon_cliente}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>Total</span><span style={{ fontSize: 12, fontWeight: 800, color: "#dc2626" }}>{money(factura.monto_total)}</span></div>
          </div>
          <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "12px 14px", marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#92400e", marginBottom: 6, textTransform: "uppercase" }}>Se eliminará permanentemente:</div>
            {["✗ El ingreso (factura)", "✗ Todos los asientos contables", "✗ Todos los detalles de asientos", factura.estado === "pagada" ? "✗ El asiento de cobro/pago" : null].filter(Boolean).map((item, i) => <div key={i} style={{ fontSize: 12, color: "#78350f", fontWeight: 500 }}>{item}</div>)}
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, color: "#374151", fontWeight: 600, display: "block", marginBottom: 8 }}>Escribe <strong style={{ color: "#dc2626" }}>{confirmWord}</strong> para confirmar:</label>
            <input value={confirmText} onChange={e => setConfirmText(e.target.value)} placeholder={`Escribe ${confirmWord}`} style={{ width: "100%", padding: "10px 14px", border: `1.5px solid ${puedeEliminar ? "#dc2626" : "#e2e8f0"}`, borderRadius: 8, fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box", fontWeight: 700 }} />
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={onClose} style={{ flex: 1, padding: "11px", border: "1.5px solid #e2e8f0", borderRadius: 8, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Cancelar</button>
            <button onClick={handleEliminar} disabled={!puedeEliminar || eliminando} style={{ flex: 1, padding: "11px", border: "none", borderRadius: 8, background: puedeEliminar ? "#dc2626" : "#f1f5f9", color: puedeEliminar ? "#fff" : "#94a3b8", fontSize: 13, fontWeight: 700, cursor: puedeEliminar ? "pointer" : "not-allowed", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
              <Trash2 size={14} />{eliminando ? "Eliminando..." : "Eliminar todo"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Modal Ver PDF ── */
function PDFViewerModal({ factura, onClose }) {
  const [zoom, setZoom] = useState(1);
  const fileId = factura.pdf_drive_id;
  const previewUrl = `https://drive.google.com/file/d/${fileId}/preview`;
  const openUrl = `https://drive.google.com/file/d/${fileId}/view`;
  const STEP = 0.25;

  const btnZoom = (onClick, label) => (
    <button onClick={onClick} style={{ width: 32, height: 32, border: "none", background: "transparent", cursor: "pointer", color: "#374151", fontSize: 17, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit" }}>{label}</button>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000075", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 250, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: "min(940px, 96vw)", height: "94vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 28px 80px #00000040" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "12px 18px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: 7, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <FileText size={16} color="#dc2626" />
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#0d1117" }}>Factura N° {factura.folio}</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>{factura.razon_cliente}</div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {/* Zoom controls */}
            <div style={{ display: "flex", alignItems: "center", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", background: "#fff" }}>
              {btnZoom(() => setZoom(z => Math.max(0.5, +(z - STEP).toFixed(2))), "−")}
              <span style={{ padding: "0 10px", fontSize: 12, fontWeight: 700, color: "#374151", minWidth: 52, textAlign: "center", borderLeft: "1px solid #e2e8f0", borderRight: "1px solid #e2e8f0", lineHeight: "32px" }}>
                {Math.round(zoom * 100)}%
              </span>
              {btnZoom(() => setZoom(z => Math.min(3, +(z + STEP).toFixed(2))), "+")}
            </div>
            <button onClick={() => setZoom(1)} style={{ padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff", color: "#64748b", fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Reset</button>
            <a href={openUrl} target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: 5, padding: "7px 12px", border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff", color: "#374151", fontSize: 12, fontWeight: 600, textDecoration: "none" }}>
              <ExternalLink size={12} /> Abrir en Drive
            </a>
            <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex" }}><X size={18} /></button>
          </div>
        </div>

        {/* PDF viewer */}
        <div style={{ flex: 1, overflow: "auto", background: "#3d4043", padding: "20px", display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
          <div style={{
            width: `${zoom * 100}%`,
            minWidth: 400,
            maxWidth: "100%",
            background: "#fff",
            borderRadius: 4,
            boxShadow: "0 4px 24px #00000040",
            overflow: "hidden",
            flexShrink: 0,
          }}>
            <iframe
              key={zoom}
              src={previewUrl}
              style={{
                width: "100%",
                height: `${Math.max(720, window.innerHeight * 0.82)}px`,
                border: "none",
                display: "block",
              }}
              title={`Factura N° ${factura.folio}`}
              allow="autoplay"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Hook contactos ── */
function useContactos() {
  const [contactos, setContactos] = useState([]);
  useEffect(() => { cargarContactos(); }, []);
  async function cargarContactos() {
    const { data } = await supabase.from("contactos").select("*").eq("activo", true).order("razon_social");
    setContactos(data || []);
  }
  async function guardarContacto(datos) {
    await supabase.from("contactos").upsert({ ...datos, activo: true }, { onConflict: "rut" });
    cargarContactos();
  }
  async function eliminarContacto(id) {
    await supabase.from("contactos").update({ activo: false }).eq("id", id);
    cargarContactos();
  }
  return { contactos, guardarContacto, eliminarContacto, recargar: cargarContactos };
}

const TIPOS = [
  { v: "cliente", l: "Cliente", color: "#3b82f6", bg: "#eff6ff" },
  { v: "proveedor", l: "Proveedor", color: "#8b5cf6", bg: "#f5f3ff" },
  { v: "ambos", l: "Ambos", color: "#10b981", bg: "#f0fdf4" },
];

/* ── Formulario Contacto (debe estar FUERA de ContactosModal para no perder foco) ── */
function FormContacto({ data, onChange, onGuardar, guardando, onCancelar }) {
  const inputStyle = { width: "100%", padding: "8px 12px", border: "1.5px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box", color: "#0d1117" };
  const selectStyle = { ...inputStyle, appearance: "none", background: "#fff" };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>RUT *</div>
          <input value={data.rut} onChange={e => onChange({ ...data, rut: e.target.value })} placeholder="76.340.538-9" style={inputStyle} disabled={!!data.id} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>Tipo *</div>
          <select value={data.tipo} onChange={e => onChange({ ...data, tipo: e.target.value })} style={selectStyle}>
            {TIPOS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>Razón Social *</div>
        <input value={data.razon_social} onChange={e => onChange({ ...data, razon_social: e.target.value })} placeholder="Empresa S.A." style={inputStyle} />
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ flex: 2 }}>
          <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>Email</div>
          <input value={data.email || ""} onChange={e => onChange({ ...data, email: e.target.value })} placeholder="contacto@empresa.com" style={inputStyle} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>Teléfono</div>
          <input value={data.telefono || ""} onChange={e => onChange({ ...data, telefono: e.target.value })} placeholder="+56 9 1234 5678" style={inputStyle} />
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ flex: 2 }}>
          <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>Dirección</div>
          <input value={data.direccion || ""} onChange={e => onChange({ ...data, direccion: e.target.value })} placeholder="Av. Providencia 1234" style={inputStyle} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, marginBottom: 3 }}>Comuna</div>
          <input value={data.comuna || ""} onChange={e => onChange({ ...data, comuna: e.target.value })} placeholder="Santiago" style={inputStyle} />
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 4 }}>
        <button onClick={onCancelar} style={{ padding: "7px 14px", border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff", color: "#64748b", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>Cancelar</button>
        <button onClick={() => onGuardar(data)} disabled={!data.rut || !data.razon_social || guardando}
          style={{ padding: "7px 16px", border: "none", borderRadius: 7, background: data.rut && data.razon_social ? "#10b981" : "#e2e8f0", color: data.rut && data.razon_social ? "#fff" : "#94a3b8", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          {guardando ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </div>
  );
}

/* ── Modal Contactos ── */
function ContactosModal({ onClose }) {
  const { contactos, guardarContacto, eliminarContacto, recargar } = useContactos();
  const [editando,  setEditando]  = useState(null);
  const [busqueda,  setBusqueda]  = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [invitando, setInvitando] = useState(null); // id del contacto en proceso
  const [toast,     setToast]     = useState(null);
  const vacio = { rut: "", razon_social: "", tipo: "cliente", email: "", telefono: "", direccion: "", comuna: "" };
  const [nuevo, setNuevo] = useState(vacio);
  const [mostrarForm, setMostrarForm] = useState(false);

  function notify(msg, type = "ok") {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  }

  async function invitarPortal(c) {
    if (!c.email) { notify("Este contacto no tiene email registrado", "err"); return; }
    setInvitando(c.id);
    try {
      const res = await fetch(N8N_INVITAR_PORTAL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: c.email, razon_social: c.razon_social }),
      });
      const data = await res.json();
      if (data.success) {
        notify(`✉️ Invitación enviada a ${c.email}`);
        recargar();
      } else {
        notify("Error al enviar invitación", "err");
      }
    } catch (e) {
      notify("Error al enviar invitación", "err");
    }
    setInvitando(null);
  }

  async function handleGuardar(c) {
    if (!c.rut.trim() || !c.razon_social.trim()) return;
    setGuardando(true);
    await guardarContacto({ rut: c.rut.trim(), razon_social: c.razon_social.trim(), tipo: c.tipo, email: c.email?.trim() || null, telefono: c.telefono?.trim() || null, direccion: c.direccion?.trim() || null, comuna: c.comuna?.trim() || null });
    setEditando(null);
    setNuevo(vacio);
    setMostrarForm(false);
    setGuardando(false);
  }

  const inputStyle = { width: "100%", padding: "8px 12px", border: "1.5px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box", color: "#0d1117" };
  const selectStyle = { ...inputStyle, appearance: "none", background: "#fff" };

  const filtrados = contactos.filter(c => {
    const q = busqueda.toLowerCase();
    const matchQ = !q || (c.razon_social || "").toLowerCase().includes(q) || (c.rut || "").toLowerCase().includes(q) || (c.email || "").toLowerCase().includes(q);
    const matchT = !filtroTipo || c.tipo === filtroTipo;
    return matchQ && matchT;
  });

  function TipoBadge({ tipo }) {
    const t = TIPOS.find(x => x.v === tipo) || TIPOS[0];
    return <span style={{ background: t.bg, color: t.color, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{t.l}</span>;
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000050", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 300, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: 660, maxHeight: "88vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px #00000025" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "18px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 8, background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center" }}><Mail size={16} color="#10b981" /></div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#0d1117" }}>Contactos</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>{contactos.length} contactos · email se autocompleta al enviar facturas</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => { setMostrarForm(!mostrarForm); setEditando(null); }} style={{ padding: "7px 14px", border: "none", borderRadius: 8, background: "#10b981", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>+ Nuevo</button>
            <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={18} /></button>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14 }}>

          {/* Formulario nuevo */}
          {mostrarForm && (
            <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "14px 16px" }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#166534", marginBottom: 10 }}>Nuevo contacto</div>
              <FormContacto data={nuevo} onChange={setNuevo} onGuardar={handleGuardar} guardando={guardando} onCancelar={() => { setMostrarForm(false); setNuevo(vacio); }} />
            </div>
          )}

          {/* Filtros */}
          <div style={{ display: "flex", gap: 8 }}>
            <div style={{ flex: 1, position: "relative" }}>
              <Search size={12} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
              <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar por nombre, RUT o email..." style={{ width: "100%", padding: "8px 12px 8px 30px", border: "1.5px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box", color: "#0d1117" }} />
            </div>
            <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)} style={{ width: 130, padding: "8px 12px", border: "1.5px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontFamily: "inherit", outline: "none", boxSizing: "border-box", color: "#0d1117", appearance: "none", background: "#fff" }}>
              <option value="">Todos</option>
              {TIPOS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
            </select>
          </div>

          {/* Lista */}
          {filtrados.length === 0 ? (
            <div style={{ textAlign: "center", color: "#94a3b8", padding: "32px 0", fontSize: 13 }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>📋</div>
              {busqueda || filtroTipo ? "Sin resultados para este filtro" : "No hay contactos guardados aún"}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {filtrados.map(c => (
                <div key={c.id} style={{ border: "1px solid #e2e8f0", borderRadius: 8, padding: "12px 14px", background: editando?.id === c.id ? "#f0fdf4" : "#fff" }}>
                  {editando?.id === c.id ? (
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#166534", marginBottom: 8 }}>Editando: {c.razon_social}</div>
                      <FormContacto data={editando} onChange={setEditando} onGuardar={handleGuardar} guardando={guardando} onCancelar={() => setEditando(null)} />
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: "#0d1117" }}>{c.razon_social}</span>
                          <TipoBadge tipo={c.tipo} />
                        </div>
                        <div style={{ fontSize: 11, color: "#64748b", display: "flex", flexWrap: "wrap", gap: "2px 12px" }}>
                          <span>{c.rut}</span>
                          {c.email && <span style={{ color: "#3b82f6" }}>✉ {c.email}</span>}
                          {c.telefono && <span>📞 {c.telefono}</span>}
                          {c.comuna && <span>📍 {c.comuna}</span>}
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: 6, flexShrink: 0, alignItems: "center" }}>
                        {/* Portal — solo para clientes */}
                        {(c.tipo === "cliente" || c.tipo === "ambos") && (
                          c.user_id ? (
                            <span style={{ padding: "4px 10px", borderRadius: 6,
                              background: "#dcfce7", color: "#16a34a",
                              fontSize: 12, fontWeight: 600,
                              display: "inline-flex", alignItems: "center", gap: 4 }}>
                              <CheckCircle size={12}/>
                              Portal activo
                            </span>
                          ) : (
                            <button
                              onClick={() => invitarPortal(c)}
                              disabled={invitando === c.id}
                              style={{ padding: "5px 10px", border: "1px solid #29abe2",
                                borderRadius: 6, background: "#fff", color: "#29abe2",
                                fontSize: 11, fontFamily: "inherit",
                                cursor: invitando === c.id ? "not-allowed" : "pointer",
                                display: "inline-flex", alignItems: "center", gap: 4,
                                opacity: invitando === c.id ? 0.6 : 1 }}>
                              <UserPlus size={11}/>
                              {invitando === c.id ? "Enviando..." : "Invitar al portal"}
                            </button>
                          )
                        )}
                        <button onClick={() => setEditando({ ...c })} style={{ padding: "5px 10px", border: "1px solid #e2e8f0", borderRadius: 6, background: "#f8fafc", color: "#374151", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>Editar</button>
                        <button onClick={() => eliminarContacto(c.id)} style={{ padding: "5px 10px", border: "1px solid #fecaca", borderRadius: 6, background: "#fef2f2", color: "#dc2626", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>Eliminar</button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {toast && (
        <div style={{ position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)",
          background: "#0d1117", color: "#fff", padding: "10px 20px", borderRadius: 8,
          fontSize: 13, fontWeight: 600, zIndex: 9999, boxShadow: "0 4px 16px #00000025",
          display: "flex", alignItems: "center", gap: 8, whiteSpace: "nowrap",
          borderLeft: `3px solid ${toast.type === "err" ? "#ef4444" : "#10b981"}` }}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}

/* ── Modal Enviar Email ── */
function EmailModal({ factura, onClose }) {
  const inputStyle = { width: "100%", padding: "9px 14px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", color: "#0d1117", background: "#fff", boxSizing: "border-box" };
  const { contactos, guardarContacto } = useContactos();
  const [desde, setDesde] = useState(CUENTAS_REMITENTE[0].email);
  const [para, setPara] = useState("");
  const [asunto, setAsunto] = useState(`Factura N° ${factura.folio} - ${factura.razon_cliente}`);
  const [cuerpo, setCuerpo] = useState(`Estimado/a,\n\nAdjunto encontrará la factura N° ${factura.folio} emitida el ${fmtDate(factura.fecha_emision)} por un total de ${money(factura.monto_total)}.\n\nQuedamos a su disposición ante cualquier consulta.\n\nSaludos cordiales,\nTuAplicacion`);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");
  const [adjuntarPdf, setAdjuntarPdf] = useState(true);
  const [guardarEmail, setGuardarEmail] = useState(false);
  const [showSugerencias, setShowSugerencias] = useState(false);

  const driveFileId = factura.pdf_drive_id || null;
  const tieneArchivo = !!driveFileId;

  // Autocompletar desde contactos por RUT
  useEffect(() => {
    const contacto = contactos.find(c => c.rut === factura.rut_cliente);
    if (contacto?.email) { setPara(contacto.email); setGuardarEmail(false); }
    else setGuardarEmail(true);
  }, [contactos]);

  const sugerencias = para.length >= 2
    ? contactos.filter(c => c.email.toLowerCase().includes(para.toLowerCase()) || (c.razon_social || "").toLowerCase().includes(para.toLowerCase()))
    : [];

  const N8N_WEBHOOK_URL = "https://tuaplicacion.app.n8n.cloud/webhook/send-email-factura";

  async function enviarEmail() {
    if (!para.trim()) { setError("Ingresa el destinatario."); return; }
    if (!asunto.trim()) { setError("Ingresa el asunto."); return; }
    if (!cuerpo.trim()) { setError("Ingresa el contenido."); return; }
    setEnviando(true);
    setError("");
    try {
      const res = await fetch(N8N_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          desde,
          para,
          asunto,
          cuerpo,
          pdf_drive_id: adjuntarPdf && tieneArchivo ? driveFileId : null,
          folio: factura.folio,
          razon_cliente: factura.razon_cliente,
        })
      });
      if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
      // Guardar contacto si está marcado
      if (guardarEmail && para.trim() && factura.rut_cliente) {
        await guardarContacto({ rut: factura.rut_cliente, razon_social: factura.razon_cliente, tipo: "cliente", email: para.trim() });
      }
      setEnviado(true);
    } catch (e) {
      setError("Error al enviar: " + e.message);
    }
    setEnviando(false);
  }

  if (enviado) {
    return (
      <div style={{ position: "fixed", inset: 0, background: "#00000050", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 250, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
        <div style={{ background: "#fff", borderRadius: 16, width: 400, padding: "40px 32px", textAlign: "center", boxShadow: "0 20px 60px #00000020" }} onClick={e => e.stopPropagation()}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#f0fdf4", border: "2px solid #bbf7d0", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}><Send size={28} color="#10b981" /></div>
          <div style={{ fontSize: 18, fontWeight: 800, color: "#0d1117", marginBottom: 8 }}>¡Email enviado!</div>
          <div style={{ fontSize: 13, color: "#64748b", marginBottom: 24 }}>La factura N° {factura.folio} fue enviada a <strong>{para}</strong></div>
          <button onClick={onClose} style={{ padding: "10px 28px", border: "none", borderRadius: 8, background: "#10b981", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Cerrar</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000050", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 250, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: 560, maxHeight: "90vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px #00000025" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "18px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center" }}><Mail size={18} color="#3b82f6" /></div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#0d1117" }}>Enviar factura por email</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>N° {factura.folio} · {factura.razon_cliente}</div>
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={18} /></button>
        </div>

        {/* Formulario */}
        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14 }}>

          {/* Desde */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Desde</label>
            <div style={{ display: "flex", gap: 8 }}>
              {CUENTAS_REMITENTE.map(c => (
                <button key={c.email} onClick={() => setDesde(c.email)} style={{ flex: 1, padding: "9px 12px", border: `1.5px solid ${desde === c.email ? "#3b82f6" : "#e2e8f0"}`, borderRadius: 8, background: desde === c.email ? "#eff6ff" : "#fff", color: desde === c.email ? "#1d4ed8" : "#374151", fontSize: 12, fontWeight: desde === c.email ? 700 : 500, cursor: "pointer", fontFamily: "inherit" }}>{c.label}</button>
              ))}
            </div>
          </div>

          {/* Para */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Para</label>
            <div style={{ position: "relative" }}>
              <input
                value={para}
                onChange={e => { setPara(e.target.value); setShowSugerencias(true); setGuardarEmail(true); }}
                onFocus={() => setShowSugerencias(true)}
                onBlur={() => setTimeout(() => setShowSugerencias(false), 150)}
                placeholder="destinatario@empresa.com"
                style={inputStyle}
              />
              {showSugerencias && sugerencias.length > 0 && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 8, boxShadow: "0 8px 24px #00000015", zIndex: 10, overflow: "hidden" }}>
                  {sugerencias.map(c => (
                    <button key={c.rut} onClick={() => { setPara(c.email); setGuardarEmail(false); setShowSugerencias(false); }}
                      style={{ width: "100%", padding: "9px 14px", border: "none", background: "transparent", cursor: "pointer", textAlign: "left", fontFamily: "inherit", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f8fafc" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#0d1117" }}>{c.razon_social || c.rut}</span>
                      <span style={{ fontSize: 12, color: "#3b82f6" }}>{c.email}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            {guardarEmail && para.includes("@") && (
              <div style={{ marginTop: 6, display: "flex", alignItems: "center", gap: 6 }}>
                <input type="checkbox" id="guardar-email" checked={guardarEmail} onChange={e => setGuardarEmail(e.target.checked)} style={{ cursor: "pointer" }} />
                <label htmlFor="guardar-email" style={{ fontSize: 11, color: "#64748b", cursor: "pointer" }}>Guardar este email para {factura.razon_cliente} (no pedirlo la próxima vez)</label>
              </div>
            )}
          </div>

          {/* Asunto */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Asunto</label>
            <input value={asunto} onChange={e => setAsunto(e.target.value)} placeholder="Asunto del correo..." style={inputStyle} />
          </div>

          {/* Cuerpo */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Contenido</label>
            <textarea value={cuerpo} onChange={e => setCuerpo(e.target.value)} rows={8} placeholder="Contenido del email..." style={{ ...inputStyle, resize: "vertical", minHeight: 160, lineHeight: 1.6 }} />
          </div>

          {/* Adjunto */}
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "12px 14px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Paperclip size={14} color={tieneArchivo ? "#3b82f6" : "#94a3b8"} />
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>Adjuntar PDF de Drive</div>
                  <div style={{ fontSize: 11, color: tieneArchivo ? "#64748b" : "#f59e0b" }}>
                    {tieneArchivo ? `pdf_drive_id: ${String(driveFileId).substring(0, 28)}...` : "⚠️ Este registro no tiene pdf_drive_id"}
                  </div>
                </div>
              </div>
              <button onClick={() => tieneArchivo && setAdjuntarPdf(!adjuntarPdf)} disabled={!tieneArchivo}
                style={{ width: 40, height: 22, borderRadius: 11, background: adjuntarPdf && tieneArchivo ? "#3b82f6" : "#e2e8f0", border: "none", cursor: tieneArchivo ? "pointer" : "not-allowed", position: "relative", transition: "background .2s", flexShrink: 0 }}>
                <div style={{ width: 18, height: 18, borderRadius: "50%", background: "#fff", position: "absolute", top: 2, left: adjuntarPdf && tieneArchivo ? 20 : 2, transition: "left .2s", boxShadow: "0 1px 3px #00000020" }} />
              </button>
            </div>
          </div>

          {error && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 12, color: "#dc2626", fontWeight: 500 }}>{error}</div>}
        </div>

        {/* Footer */}
        <div style={{ padding: "16px 24px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 10, flexShrink: 0 }}>
          <button onClick={onClose} style={{ flex: 1, padding: "11px", border: "1.5px solid #e2e8f0", borderRadius: 8, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Cancelar</button>
          <button onClick={enviarEmail} disabled={enviando} style={{ flex: 2, padding: "11px", border: "none", borderRadius: 8, background: enviando ? "#93c5fd" : "#3b82f6", color: "#fff", fontSize: 13, fontWeight: 700, cursor: enviando ? "not-allowed" : "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
            <Send size={14} />{enviando ? "Enviando..." : `Enviar desde ${desde.split("@")[0]}@tuaplicacion.cl`}
          </button>
        </div>
      </div>
    </div>
  );
}

function Comprobante({ factura, onClose }) {
  const [asientos, setAsientos] = useState([]);
  const [detalles, setDetalles] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function cargar() {
      const { data: aa } = await supabase.from("asientos").select("*").eq("ingreso_id", factura.id).order("created_at");
      if (aa?.length) { setAsientos(aa); const det = {}; for (const a of aa) { const { data: d } = await supabase.from("asiento_detalle").select("*").eq("asiento_id", a.id).order("orden"); det[a.id] = d || []; } setDetalles(det); }
      setLoading(false);
    }
    cargar();
  }, [factura.id]);
  const TIPO_LABEL = { ingreso: "Asiento de Emisión", cobro: "Asiento de Cobro", ajuste: "Ajuste" };
  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000050", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: 580, maxHeight: "85vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px #00000025" }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: "18px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}><BookOpen size={18} color="#29abe2" /><div><div style={{ fontSize: 14, fontWeight: 700, color: "#0d1117" }}>Comprobantes Contables</div><div style={{ fontSize: 11, color: "#94a3b8" }}>Factura N° {factura.folio} · {factura.razon_cliente}</div></div></div>
          <div style={{ display: "flex", gap: 8 }}><button onClick={() => window.print()} style={{ background: "#29abe210", border: "1px solid #29abe230", borderRadius: 7, padding: "6px 12px", cursor: "pointer", color: "#29abe2", fontSize: 12, fontWeight: 600, display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}><Printer size={13} /> Imprimir</button><button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={18} /></button></div>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}>
          {loading ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 32 }}>Cargando asientos...</div> : asientos.length === 0 ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 32 }}>No se encontraron asientos contables.</div> : (
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              {asientos.map((a, idx) => (
                <div key={a.id}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                    <div style={{ background: idx === 0 ? "#29abe210" : "#f0fdf4", border: `1px solid ${idx === 0 ? "#29abe230" : "#bbf7d0"}`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, color: idx === 0 ? "#29abe2" : "#166534" }}>{TIPO_LABEL[a.tipo] || a.tipo}</div>
                    <div style={{ fontSize: 12, color: "#64748b" }}>N° {a.numero} · {fmtDate(a.fecha)}</div>
                    <div style={{ fontSize: 12, color: "#94a3b8", flex: 1 }}>{a.glosa}</div>
                  </div>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead><tr style={{ background: "#0d1117" }}>{["CÓDIGO", "CUENTA", "DEBE", "HABER"].map(h => <th key={h} style={{ padding: "8px 12px", textAlign: h === "DEBE" || h === "HABER" ? "right" : "left", color: "#fff", fontWeight: 700, fontSize: 10 }}>{h}</th>)}</tr></thead>
                    <tbody>{(detalles[a.id] || []).map((d, i) => <tr key={d.id} style={{ borderBottom: "1px solid #f0f4f8", background: i % 2 === 0 ? "#fff" : "#fafbfc" }}><td style={{ padding: "9px 12px", color: "#29abe2", fontFamily: "monospace", fontWeight: 700, fontSize: 11 }}>{d.cuenta_codigo}</td><td style={{ padding: "9px 12px", color: "#374151" }}>{d.cuenta_nombre}</td><td style={{ padding: "9px 12px", textAlign: "right", fontWeight: d.debe > 0 ? 700 : 400, color: d.debe > 0 ? "#0d1117" : "#cbd5e1" }}>{d.debe > 0 ? money(d.debe) : "—"}</td><td style={{ padding: "9px 12px", textAlign: "right", fontWeight: d.haber > 0 ? 700 : 400, color: d.haber > 0 ? "#0d1117" : "#cbd5e1" }}>{d.haber > 0 ? money(d.haber) : "—"}</td></tr>)}</tbody>
                    <tfoot><tr style={{ background: "#f8fafc", borderTop: "2px solid #e2e8f0" }}><td colSpan={2} style={{ padding: "9px 12px", fontWeight: 800, fontSize: 12 }}>TOTALES</td><td style={{ padding: "9px 12px", textAlign: "right", fontWeight: 800 }}>{money(a.total_debe)}</td><td style={{ padding: "9px 12px", textAlign: "right", fontWeight: 800 }}>{money(a.total_haber)}</td></tr></tfoot>
                  </table>
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}><span style={{ background: a.cuadrado ? "#e8f5e9" : "#fce4ec", color: a.cuadrado ? "#2e7d32" : "#c62828", borderRadius: 6, padding: "3px 10px", fontSize: 10, fontWeight: 700 }}>{a.cuadrado ? "✓ Cuadrado" : "✗ Descuadrado"}</span></div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function DetalleModal({ factura, onClose, onVerComprobante, onMarcarPagada, onEliminar, onEnviarEmail, onVerPdf }) {
  const [fechaPago, setFechaPago] = useState(factura?.fecha_pago || "");
  const [guardando, setGuardando] = useState(false);
  if (!factura) return null;
  async function handlePagar() { setGuardando(true); const fecha = fechaPago || new Date().toISOString().split("T")[0]; await onMarcarPagada(factura.id, fecha); setGuardando(false); onClose(); }
  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000040", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, fontFamily: "'DM Sans', sans-serif" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 16, width: 480, boxShadow: "0 20px 60px #00000020", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div><div style={{ fontSize: 16, fontWeight: 700, color: "#0d1117" }}>Factura N° {factura.folio}</div><div style={{ fontSize: 12, color: "#94a3b8", marginTop: 2 }}>{factura.razon_cliente}</div></div>
            <EstadoBadge estado={factura.estado} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button onClick={() => { onClose(); setTimeout(() => onEliminar(factura), 100); }} title="Eliminar" style={{ width: 34, height: 34, border: "1.5px solid #fecaca", borderRadius: 8, background: "#fef2f2", cursor: "pointer", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center" }}><Trash2 size={15} /></button>
            <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}><X size={20} /></button>
          </div>
        </div>
        <div style={{ padding: "20px 24px" }}>
          {[["RUT", factura.rut_cliente], ["Razón Social", factura.razon_cliente], ["Fecha Emisión", fmtDate(factura.fecha_emision)], ["Fecha Pago", fmtDate(factura.fecha_pago)], ["Concepto", factura.concepto], ["Tipo DTE", factura.tipo_dte], ["Monto Neto", money(factura.monto_neto)], ["IVA 19%", money(factura.iva)], ["Total", money(factura.monto_total)], ["Período", factura.periodo]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px solid #f8fafc", fontSize: 13 }}>
              <span style={{ color: "#64748b", fontWeight: 600 }}>{k}</span>
              <span style={{ color: "#0d1117", fontWeight: 500, textAlign: "right", maxWidth: "60%" }}>{v || "—"}</span>
            </div>
          ))}
          <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
            <button onClick={() => onVerComprobante(factura)} style={{ flex: 1, padding: "10px", background: "#0d1117", border: "none", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}><BookOpen size={13} /> Comprobantes</button>
            {factura.pdf_drive_id && (
              <button onClick={() => { onClose(); setTimeout(() => onVerPdf(factura), 100); }} style={{ flex: 1, padding: "10px", background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 8, color: "#dc2626", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}><FileText size={13} /> Ver PDF</button>
            )}
            <button onClick={() => { onClose(); setTimeout(() => onEnviarEmail(factura), 100); }} style={{ flex: 1, padding: "10px", background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 8, color: "#1d4ed8", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}><Mail size={13} /> Enviar email</button>
          </div>
          {factura.estado !== "pagada" && factura.estado !== "anulada" && (
            <div style={{ marginTop: 12, padding: "14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#166534", marginBottom: 10 }}>Registrar pago</div>
              <input type="date" value={fechaPago} onChange={e => setFechaPago(e.target.value)} style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #bbf7d0", borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", marginBottom: 10, boxSizing: "border-box", background: "#fff" }} />
              <button onClick={handlePagar} disabled={guardando} style={{ width: "100%", padding: "10px", border: "none", borderRadius: 8, background: "#10b981", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>{guardando ? "Guardando..." : "✓ Marcar como pagada"}</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const POR_PAGINA = 20;

export default function Ingresos() {
  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [comprobante, setComprobante] = useState(null);
  const [filtroOpen, setFiltroOpen] = useState(false);
   const [cobranza, setCobranza] = useState(false);
//
  const [pagoMasivo, setPagoMasivo] = useState(false);
  const [emailMasivo, setEmailMasivo] = useState(false);
  const [seleccionados, setSeleccionados] = useState(new Set());
  const [periodos, setPeriodos] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [filtros, setFiltros] = useState({ busqueda: "", periodo: "", estado: "emitida", fechaDesde: "", fechaHasta: "" });
  const [facturaAEliminar, setFacturaAEliminar] = useState(null);
  const [facturaEmail, setFacturaEmail] = useState(null);
  const [facturaPdf, setFacturaPdf] = useState(null);
  const [verContactos, setVerContactos] = useState(false);
  const [portalClienteToken, setPortalClienteToken] = useState(null);
  const [toastPortal, setToastPortal] = useState(false);

  function setFiltro(k, v) { setFiltros(f => ({ ...f, [k]: v })); setPagina(1); }
  function limpiarFiltros() { setFiltros({ busqueda: "", periodo: "", estado: "", fechaDesde: "", fechaHasta: "" }); setPagina(1); }

  useEffect(() => { cargar(); }, [filtros.periodo, filtros.estado, filtros.fechaDesde, filtros.fechaHasta]);

  useEffect(() => {
    if (seleccionados.size === 0) { setPortalClienteToken(null); return; }
    const sel = facturas.filter(f => seleccionados.has(f.id));
    const ruts = [...new Set(sel.map(f => f.rut_cliente).filter(Boolean))];
    if (ruts.length !== 1) { setPortalClienteToken(null); return; }
    supabase.from("contactos").select("token").eq("rut", ruts[0]).limit(1).maybeSingle()
      .then(({ data }) => setPortalClienteToken(data?.token || null));
  }, [seleccionados, facturas]);

  async function cargar() {
    setLoading(true);
    let q = supabase.from("ingresos").select("*").order("fecha_emision", { ascending: false });
    if (filtros.periodo) q = q.eq("periodo", filtros.periodo);
    if (filtros.estado) q = q.eq("estado", filtros.estado);
    if (filtros.fechaDesde) q = q.gte("fecha_emision", filtros.fechaDesde);
    if (filtros.fechaHasta) q = q.lte("fecha_emision", filtros.fechaHasta);
    const { data } = await q;
    setFacturas(data || []);
    const { data: ps } = await supabase.from("ingresos").select("periodo").order("periodo", { ascending: false });
    setPeriodos([...new Set((ps || []).map(p => p.periodo).filter(Boolean))]);
    setLoading(false);
  }

  const filtradas = facturas.filter(f => {
    if (!filtros.busqueda) return true;
    const q = filtros.busqueda.toLowerCase();
    return (f.razon_cliente || "").toLowerCase().includes(q) || (f.rut_cliente || "").toLowerCase().includes(q) || String(f.folio || "").includes(q);
  });
  const paginadas = filtradas.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

  async function marcarPagada(id, fechaPago) {
    const { error } = await supabase.from("ingresos").update({ estado: "pagada", fecha_pago: fechaPago }).eq("id", id);
    if (error) { alert("Error: " + error.message); return; }
    await supabase.rpc("asiento_pago_ingreso", { p_ingreso_id: id, p_fecha_pago: fechaPago });
    setFacturas(prev => prev.map(f => f.id === id ? { ...f, estado: "pagada", fecha_pago: fechaPago } : f));
    setSelected(prev => prev?.id === id ? { ...prev, estado: "pagada", fecha_pago: fechaPago } : prev);
  }

  async function pagarSeleccionados(ids, fechaPago) {
    for (const id of ids) { await supabase.from("ingresos").update({ estado: "pagada", fecha_pago: fechaPago }).eq("id", id); await supabase.rpc("asiento_pago_ingreso", { p_ingreso_id: id, p_fecha_pago: fechaPago }); }
    setFacturas(prev => prev.map(f => ids.includes(f.id) ? { ...f, estado: "pagada", fecha_pago: fechaPago } : f));
    setSeleccionados(new Set());
  }

  async function eliminarIngreso(id) {
    try {
      const { data: asientos } = await supabase.from("asientos").select("id").eq("ingreso_id", id);
      const asientoIds = (asientos || []).map(a => a.id);
      if (asientoIds.length > 0) { const { error: e } = await supabase.from("asiento_detalle").delete().in("asiento_id", asientoIds); if (e) throw new Error(e.message); }
      const { error: e2 } = await supabase.from("asientos").delete().eq("ingreso_id", id); if (e2) throw new Error(e2.message);
      const { error: e3 } = await supabase.from("ingresos").delete().eq("id", id); if (e3) throw new Error(e3.message);
      setFacturas(prev => prev.filter(f => f.id !== id));
    } catch (err) { alert("❌ " + err.message); }
  }

  function handleEliminar(f) { setSelected(null); setTimeout(() => setFacturaAEliminar(f), 100); }
  function handleEnviarEmail(f) { setSelected(null); setTimeout(() => setFacturaEmail(f), 100); }
  function handleVerPdf(f) { setSelected(null); setTimeout(() => setFacturaPdf(f), 100); }
  function toggleSeleccion(id) { setSeleccionados(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; }); }
  function toggleTodos() { setSeleccionados(seleccionados.size === paginadas.length ? new Set() : new Set(paginadas.map(f => f.id))); }

  function exportarExcel() {
    const rows = filtradas.map(f => ({ "Folio": f.folio, "RUT Cliente": f.rut_cliente, "Razón Social": f.razon_cliente, "Fecha Emisión": f.fecha_emision, "Fecha Pago": f.fecha_pago || "", "Concepto": f.concepto, "Tipo DTE": f.tipo_dte, "Monto Neto": f.monto_neto, "IVA": f.iva, "Monto Total": f.monto_total, "Estado": f.estado, "Período": f.periodo }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ingresos");
    XLSX.writeFile(wb, `ingresos_${new Date().toISOString().split("T")[0]}.xlsx`);
  }

  const hayFiltros = Object.values(filtros).some(v => v);
  const totalNeto = filtradas.reduce((s, f) => s + (f.monto_neto || 0), 0);
  const totalIVA = filtradas.reduce((s, f) => s + (f.iva || 0), 0);
  const totalBruto = filtradas.reduce((s, f) => s + (f.monto_total || 0), 0);
  const pendientes = filtradas.filter(f => f.estado === "emitida").length;
  const facturasSeleccionadas = filtradas.filter(f => seleccionados.has(f.id));

  return (
    <div style={{ padding: "28px 32px", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div><h1 style={{ fontSize: 22, fontWeight: 800, color: "#0d1117", margin: 0 }}>Ingresos</h1><p style={{ color: "#94a3b8", fontSize: 13, margin: "4px 0 0" }}>Facturas emitidas · contabilizadas desde Google Drive</p></div>
        <div style={{ display: "flex", gap: 10 }}>
          {seleccionados.size > 0 && <button onClick={() => setPagoMasivo(true)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 16px", border: "none", borderRadius: 8, background: "#10b981", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}><CalendarCheck size={15} /> Pagar {seleccionados.size} · {money(facturasSeleccionadas.reduce((s, f) => s + (f.monto_total || 0), 0))}</button>}
          {seleccionados.size > 0 && <button onClick={() => setEmailMasivo(true)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 16px", border: "none", borderRadius: 8, background: "#3b82f6", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}><Mail size={15} /> Enviar {seleccionados.size} {seleccionados.size === 1 ? "factura" : "facturas"}</button>}
      {seleccionados.size > 0 &&
      filtradas.filter(f => seleccionados.has(f.id) && f.estado === "emitida").length > 0 && (
      <button onClick={() => setCobranza(true)}
        style={{ display:"flex", alignItems:"center", gap:7, padding:"9px 16px",
          border:"none", borderRadius:8, background:"#dc2626", color:"#fff",
          fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
        <Mail size={15} />
        Cobranza ({filtradas.filter(f => seleccionados.has(f.id) && f.estado === "emitida").length})
      </button>
    )}
          {seleccionados.size > 0 && portalClienteToken && (
            <button onClick={async () => {
              await navigator.clipboard.writeText(`https://app.tuaplicacion.cl/?ctoken=${portalClienteToken}`);
              setToastPortal(true);
              setTimeout(() => setToastPortal(false), 2500);
            }} style={{ display:"flex", alignItems:"center", gap:7, padding:"9px 16px",
              border:"1.5px solid #e2e8f0", borderRadius:8, background:"#fff", color:"#374151",
              fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>
              <ExternalLink size={14}/> Portal cliente
            </button>
          )}
          <button onClick={exportarExcel} style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 16px", border: "1.5px solid #e2e8f0", borderRadius: 8, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}><Download size={14} /> Excel</button>
          <button onClick={() => setVerContactos(true)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 16px", border: "1.5px solid #e2e8f0", borderRadius: 8, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}><Mail size={14} /> Contactos</button>
          <button onClick={() => setFiltroOpen(true)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 16px", border: `1.5px solid ${hayFiltros ? "#29abe2" : "#e2e8f0"}`, borderRadius: 8, background: hayFiltros ? "#29abe210" : "#fff", color: hayFiltros ? "#29abe2" : "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}><Filter size={14} /> Filtros {hayFiltros && <span style={{ background: "#29abe2", color: "#fff", borderRadius: 10, padding: "1px 6px", fontSize: 10 }}>ON</span>}<ChevronRight size={13} /></button>
        </div>
      </div>

      <div style={{ display: "flex", gap: 14, marginBottom: 24 }}>
        <KPI icon={FileText}   label="Facturas"    value={filtradas.length}  color="#29abe2" sub={`${pendientes} pendientes`} />
        <KPI icon={DollarSign} label="Neto Total"  value={money(totalNeto)}  color="#10b981" />
        <KPI icon={TrendingUp} label="IVA Débito"  value={money(totalIVA)}   color="#f59e0b" />
        <KPI icon={Clock}      label="Total Bruto" value={money(totalBruto)} color="#8b5cf6" />
      </div>

      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 6px #0000000a" }}>
        <div style={{ padding: "14px 20px", borderBottom: "1px solid #e2e8f0" }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#0d1117" }}>📄 {filtradas.length} facturas{hayFiltros ? " (filtradas)" : ""}{seleccionados.size > 0 && <span style={{ marginLeft: 8, color: "#29abe2" }}>· {seleccionados.size} seleccionadas</span>}</span>
        </div>
        {loading ? <div style={{ padding: 48, textAlign: "center", color: "#94a3b8" }}>Cargando...</div> : filtradas.length === 0 ? (
          <div style={{ padding: 48, textAlign: "center", color: "#94a3b8" }}><div style={{ fontSize: 32, marginBottom: 12 }}>📂</div><div style={{ fontWeight: 700, color: "#64748b" }}>Sin resultados</div></div>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: "#f8fafc" }}>
                    <th style={{ padding: "10px 16px", borderBottom: "1px solid #e2e8f0", width: 40 }}>
                      <button onClick={toggleTodos} style={{ background: "none", border: "none", cursor: "pointer", color: seleccionados.size === paginadas.length && paginadas.length > 0 ? "#29abe2" : "#94a3b8", display: "flex" }}>{seleccionados.size === paginadas.length && paginadas.length > 0 ? <CheckSquare size={16} /> : <Square size={16} />}</button>
                    </th>
                    {["Folio","Cliente","RUT","Emisión","Pago","Días","Concepto","Total","Estado",""].map((h, i) => (
                      <th key={i} style={{ padding: "10px 16px", textAlign: h === "Total" ? "right" : "left", color: "#94a3b8", fontWeight: 700, fontSize: 10, letterSpacing: 1.5, textTransform: "uppercase", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginadas.map(f => {
                    const isSel = seleccionados.has(f.id);
                    return (
                      <tr key={f.id} style={{ borderBottom: "1px solid #f8fafc", background: isSel ? "#f0f9ff" : "transparent", cursor: "pointer" }} onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = "#f8fafc"; }} onMouseLeave={e => { if (!isSel) e.currentTarget.style.background = "transparent"; }}>
                        <td style={{ padding: "11px 16px" }} onClick={() => toggleSeleccion(f.id)}><button style={{ background: "none", border: "none", cursor: "pointer", color: isSel ? "#29abe2" : "#cbd5e1", display: "flex" }}>{isSel ? <CheckSquare size={16} /> : <Square size={16} />}</button></td>
                        <td style={{ padding: "11px 16px", fontWeight: 700, color: "#29abe2" }} onClick={() => setSelected(f)}>{f.folio || "—"}</td>
                        <td style={{ padding: "11px 16px", color: "#0d1117", fontWeight: 600 }} onClick={() => setSelected(f)}>{f.razon_cliente || "—"}</td>
                        <td style={{ padding: "11px 16px", color: "#64748b", fontFamily: "monospace", fontSize: 12 }} onClick={() => setSelected(f)}>{f.rut_cliente || "—"}</td>
                        <td style={{ padding: "11px 16px", color: "#64748b", whiteSpace: "nowrap" }} onClick={() => setSelected(f)}>{fmtDate(f.fecha_emision)}</td>
                        <td style={{ padding: "11px 16px", color: f.fecha_pago ? "#2e7d32" : "#cbd5e1", whiteSpace: "nowrap", fontSize: 12 }} onClick={() => setSelected(f)}>{fmtDate(f.fecha_pago)}</td>
                         <td style={{ padding:"11px 16px", textAlign:"center" }} onClick={() => setSelected(f)}><DiasBadge dias={diasSinPagar(f)} />    </td>
                        <td style={{ padding: "11px 16px", color: "#64748b", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} onClick={() => setSelected(f)}>{f.concepto || "—"}</td>
                        <td style={{ padding: "11px 16px", textAlign: "right", fontWeight: 800 }} onClick={() => setSelected(f)}>{money(f.monto_total)}</td>
                        <td style={{ padding: "11px 16px" }} onClick={() => setSelected(f)}><EstadoBadge estado={f.estado} /></td>
                        <td style={{ padding: "11px 10px" }}>
                          <div style={{ display: "flex", gap: 4 }}>
                            {f.pdf_drive_id && (
                              <button onClick={e => { e.stopPropagation(); handleVerPdf(f); }} title="Ver PDF" style={{ width: 28, height: 28, border: "1px solid #fecaca", borderRadius: 6, background: "#fef2f2", cursor: "pointer", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center" }}><Eye size={12} /></button>
                            )}
                            <button onClick={e => { e.stopPropagation(); handleEnviarEmail(f); }} title="Enviar email" style={{ width: 28, height: 28, border: "1px solid #bfdbfe", borderRadius: 6, background: "#eff6ff", cursor: "pointer", color: "#3b82f6", display: "flex", alignItems: "center", justifyContent: "center" }}><Mail size={12} /></button>
                            <button onClick={e => { e.stopPropagation(); handleEliminar(f); }} title="Eliminar" style={{ width: 28, height: 28, border: "1px solid #fecaca", borderRadius: 6, background: "#fef2f2", cursor: "pointer", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center" }}><Trash2 size={12} /></button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Paginacion total={filtradas.length} pagina={pagina} porPagina={POR_PAGINA} onChange={p => { setPagina(p); setSeleccionados(new Set()); }} />
          </>
        )}
      </div>

      <FiltroPanel open={filtroOpen} onClose={() => setFiltroOpen(false)} filtros={filtros} onChange={setFiltro} periodos={periodos} onLimpiar={limpiarFiltros} />
      <DetalleModal factura={selected} onClose={() => setSelected(null)} onVerComprobante={(f) => { setSelected(null); setComprobante(f); }} onMarcarPagada={marcarPagada} onEliminar={handleEliminar} onEnviarEmail={handleEnviarEmail} onVerPdf={handleVerPdf} />
      {comprobante && <Comprobante factura={comprobante} onClose={() => setComprobante(null)} />}
      {pagoMasivo && <PagoMasivoModal facturas={facturasSeleccionadas} onClose={() => setPagoMasivo(false)} onConfirm={pagarSeleccionados} />}
      {emailMasivo && <EmailMasivoModal facturas={facturasSeleccionadas} onClose={() => { setEmailMasivo(false); setSeleccionados(new Set()); }} />}
      {facturaAEliminar && <ConfirmarEliminarModal factura={facturaAEliminar} onClose={() => setFacturaAEliminar(null)} onConfirm={eliminarIngreso} />}
      {facturaEmail && <EmailModal factura={facturaEmail} onClose={() => setFacturaEmail(null)} />}
      {facturaPdf && <PDFViewerModal factura={facturaPdf} onClose={() => setFacturaPdf(null)} />}
      {verContactos && <ContactosModal onClose={() => setVerContactos(false)} />}

      {toastPortal && (
        <div style={{ position:"fixed", bottom:24, left:"50%", transform:"translateX(-50%)",
          background:"#0d1117", color:"#fff", padding:"10px 20px", borderRadius:8,
          fontSize:13, fontWeight:600, zIndex:9999, boxShadow:"0 4px 16px #00000025",
          display:"flex", alignItems:"center", gap:8, whiteSpace:"nowrap" }}>
          ✓ Link del portal copiado
        </div>
      )}
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');`}</style>


      {cobranza && (
      <CobranzaModal
        facturas={filtradas.filter(f => seleccionados.has(f.id) && f.estado === "emitida")}
        onClose={() => { setCobranza(false); setSeleccionados(new Set()); }}
      />
    )}
    </div>
  );
}
